<template>
    <el-dialog :title="dialog.title" border :type="dialog.type" :visible.sync="dialogFormVisible" width="50%">
        <!-- 查看有效 -->
        <div>
            <el-table :data="customerData" style="width: 100%" height="500px">
                <!-- <el-table-column prop="upload_id" label="编号" width="180">
                </el-table-column> -->
                <el-table-column prop="realname" label="联系人" width="180">
                </el-table-column>
                <el-table-column v-if="type=='wash'" prop="mobile" label="手机号">
                    <template slot-scope="scope">
                        <el-link type="primary" @click="getMemberDetail(scope.row)">{{scope.row.mobile}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column v-else prop="mobile" label="手机号">
                </el-table-column>
                <el-table-column prop="source_text" label="渠道来源">
                </el-table-column>
                <el-table-column prop="city_text" label="城市名称">
                </el-table-column>
                <el-table-column prop="create_time" label="上传时间">
                </el-table-column>
            </el-table>
        </div>
        <div class="footer-box">
            <div class="download">
                <el-link v-if="type == 'duplicate'" type="text" icon="el-icon-download" class="mr10"
                    @click="duplicate">重复导出</el-link>
                <el-link v-if="type == 'noduplicate'" type="text" icon="el-icon-download" class="mr10"
                    @click="noduplicate">非重复导出</el-link>
            </div>
            <div class="pagination" v-if="isPagination">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="pagination.page" :page-sizes="[10, 15, 30, 50, 100, 300, 1000]"
                    :page-size="pagination.limit" layout="total, sizes, prev, pager, next, jumper"
                    :total="pagination.total"></el-pagination>
            </div>
        </div>
        <member-detail ref="memberDetail" :parent="_self"></member-detail>
    </el-dialog>
</template>

<script>
import memberDetail from '@/components/member/detail.vue';
export default {
    components: {
        memberDetail
    },
    data() {
        return {
            customerData: [],
            dialogFormVisible: false,
            dialog: {
                title: '',
                visible: false,
                type: ''
            },
            detail: "",
            type: "",
            //反映翻页
            pagination: {
                page: 1,
                limit: 15,
                total: 0
            },
            isPagination: {},
        }
    },
    created() {

    },
    methods: {
        noduplicate() {
            let _this = this;
            let url = this.axios.defaults.baseURL + '/api/customer.distribution/exportActiveCustomer';
            this.openPostWindow(url, "非重复下载", _this.detail.id)

        },
        //下载
        duplicate() {
            let _this = this;
            let url = this.axios.defaults.baseURL + '/api/customer.distribution/exportDuplicateCustomer';
            this.openPostWindow(url, "下载", _this.detail.id)

        },
        openPostWindow(url, name, id) {
            var tempForm = document.createElement('form')
            tempForm.id = 'tempForm1'
            tempForm.method = 'post';
            tempForm.action = url;
            tempForm.target = name;
            var hideId = document.createElement("input");
            hideId.type = 'hidden';
            hideId.name = "id";
            hideId.value = id;
            tempForm.appendChild(hideId);
            var hideToken = document.createElement("input");
            hideToken.type = 'hidden';
            hideToken.name = "token";
            hideToken.value = localStorage.getItem("token");
            tempForm.appendChild(hideToken);

            tempForm.addEventListener("onsubmit", function () {
                openWindow(name)
            });
            document.body.appendChild(tempForm);
            tempForm.submit();
            document.body.removeChild(tempForm);

            return false
        },
        openWindow(name) {
            window.open('about:blank', name,
                'height=400,width=400,top=0,left=0,toolbar =yes,menubar =yes,scrollbars=yes,resizable=yes,location=yes,status=yes'
            )
        },
        // 分页
        handleSizeChange(val) {
            this.pagination.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.pagination.page = val;
            this.getTableData();
        },
        //获取客资详情
        getMemberDetail(row) {
            let _this = this;
            if (_this.$refs['memberDetail']) {
                _this.$refs['memberDetail'].showCustomerDrawer(row);
            } else {
                _this.$nextTick(function () {
                    _this.$refs['memberDetail'].showCustomerDrawer(row);
                })
            }
        },
        showDrawer(row, type) {
            let _this = this;
            _this.dialogFormVisible = true;
            _this.detail = row;
            _this.type = type;
            if (type == 'duplicate') {
                _this.dialog.title = "重复客资 ";
                _this.getTableData()
            }

            if (type == 'noduplicate') {
                _this.dialog.title = "非重复客资 ";
                _this.getTableData()
            }

            if (type == 'wash') {
                _this.dialog.title = "清洗有效 ";
                _this.getTableData()
            }

            if (type == 'recommend') {
                _this.dialog.title = "推荐有效 ";
                _this.getTableData()
            }
        },
        // 非重复客资 
        getTableData(options) {
            let _this = this;

            if (_this.type == 'duplicate') {
                let url = '/api/customer.distribution/getUploadDuplicate';
                let query = {
                    id: _this.detail.id
                };
                query['pagination'] = this.pagination;
                this.$post(url, query).then(function (response) {
                    if (response.code == 200) {
                        _this.customerData = response.data.list;
                        _this.pagination = response.data.pagination;
                        _this.loading = false;
                    }
                });
            } else if (_this.type == 'wash') {
                // 清洗有效明细
                let url = '/api/customer.distribution/getWashBom';
                let query = {
                    id: _this.detail.id
                };
                query['pagination'] = this.pagination;
                this.$post(url, query).then(function (response) {
                    if (response.code == 200) {
                        _this.customerData = response.data.list;
                        _this.pagination = response.data.pagination;
                        _this.loading = false;
                    }
                });
            } else if (_this.type == 'recommend') {
                // 推荐有效明细
                let url = '/api/customer.distribution/getRecommendBom';
                let query = {
                    id: _this.detail.id
                };
                query['pagination'] = this.pagination;
                this.$post(url, query).then(function (response) {
                    if (response.code == 200) {
                        _this.customerData = response.data.list;
                        _this.pagination = response.data.pagination;
                        _this.loading = false;
                    }
                });
            } else {
                let url = '/api/customer.distribution/getUploadActive';
                let query = {
                    id: _this.detail.id
                };
                query['pagination'] = this.pagination;
                this.$post(url, query).then(function (response) {
                    if (response.code == 200) {
                        _this.customerData = response.data.list;
                        _this.pagination = response.data.pagination;
                        _this.loading = false;
                    }
                });
            }


        },
        // 获取重复客资 
        getUploadDuplicate(options) {
            let _this = this;
            _this.loading = true;

        },
        submit() {

        }
    }
}
</script>